import { c as _c } from "react/compiler-runtime";
import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import getFallbackDebugMessage from './getFallbackDebugMessage';

// Set to true to render a debugging message when loading instead of the
// specified fallback component.
const SHOW_DEBUG_FALLBACKS = false;
const SuspenseWithLoader = t0 => {
  const $ = _c(6);
  const {
    children,
    fallback
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== fallback) {
    t1 = SHOW_DEBUG_FALLBACKS ? getFallbackDebugMessage(children) : fallback;
    $[0] = children;
    $[1] = fallback;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const fallbackToShow = t1;
  let t2;
  if ($[3] !== children || $[4] !== fallbackToShow) {
    t2 = <Suspense fallback={fallbackToShow}>{children}</Suspense>;
    $[3] = children;
    $[4] = fallbackToShow;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
SuspenseWithLoader.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node
};
export default SuspenseWithLoader;